import {AbstractControl, ValidationErrors} from '@angular/forms';

export interface FormGroupValidatorFn {
  (group: AbstractControl): ValidationErrors | null;
}
